/* eslint-disable import/order */
import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getAIContextPanelResources } from '@jira/router-resources__service-desk-ai-context-panel/src/getAIContextPanelResources.tsx';
import { getResolutionPlanSSRResource } from '@jira/router-resources__service-desk-ai-context-panel/src/ResolutionPlanSSRResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskReportsCustomIssueRoute } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskReportsCustomIssueRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ReportsIssueView, { LazyServicedeskReportsIssueView } from './ui/issue-view/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskReportsCustomIssueRouteEntry: Route = createEntry(
	servicedeskReportsCustomIssueRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ReportsIssueView,
		layout: composeLayouts(serviceProjectLayout, embeddedIssuePreloadLayoutBuilder()),

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getIssueViewResources(),
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			...getAIContextPanelResources(),
			...getResolutionPlanSSRResource(),
		],

		afterPaint: [LazyIssueApp],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskReportsIssueView],
		ufoName: 'service-management.reports.issue',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
